import { render, staticRenderFns } from "./ProductClassifyLook.vue?vue&type=template&id=68c14ee2&scoped=true&"
import script from "./ProductClassifyLook.vue?vue&type=script&lang=js&"
export * from "./ProductClassifyLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c14ee2",
  null
  
)

export default component.exports